angular.module('app.coverage.events.eventsService', [])
  .factory('app.coverage.events.eventsService', [
    '$q', '$http', '$httpParamSerializerJQLike',
    function ($q, $http, $httpParamSerializerJQLike) {

      let events;
      events = {
        list: null,
        error: null,
        typeList: {
          limit: 100,
          itemsPerPage: 20,
          upcoming: {
            count: null,
            list: null,
            current_page: 0,
            page_count: null
          },
          current: {
            count: null,
            list: null,
            current_page: 0,
            page_count: null
          },
          past: {
            count: null,
            list: null,
            current_page: 0,
            page_count: null
          }
        },
        retrieve: function (params) {
          params = $httpParamSerializerJQLike(params);
          return $http.get(window.location.api('events/?' + params))
            .then((response) => {
              let data = response.data;

              if (data.error) {
                events.error = data.error;
              } else {
                events.error = null;
                events.list = data;
              }
            });
        },
        get_teams_for: function (event_id) {
          if (event_id) {
            return $http.get(window.location.api('/events/' + event_id + '/teams'));
          }
        },
        getEventsByType: (type) => {
          let eventType = type ? type : 'upcoming';
          let params = $httpParamSerializerJQLike({
            limit: events.typeList.limit
          });

          if (events.typeList[eventType].list && events.typeList[eventType].list.length) {
            return $q.when(events.typeList[eventType]);
          }
          return $http.get(window.location.api('events_' + eventType + '?' + params))
            .then((response) => {
              let data = response.data;

              if (data.error) {
                return events.error = data.error;
              }
              if (data.results) {
                events.typeList[eventType].list = data.results;
                events.typeList[eventType].count = data.results.length;
                events.typeList[eventType].current_page = 0;
                events.typeList[eventType].page_count = Math.ceil(data.results.length / 3);
                return events.error = null;
              }
              return data
            });
        }
      };

      return events;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/coverage/events/eventsService.js